import { Breadcrumbs } from '@material-ui/core';
import Link from 'next/link';
import { useRouter } from 'next/router';
import useGetVehicle from '../hooks/useGetVehicle';

const VehicleBreadcrumbs = () => {
  const { vehicle } = useGetVehicle();
  const router = useRouter();

  return (
    <Breadcrumbs separator="|">
      <button className="text-breadcrumbs" type="button" onClick={() => router.back()}>
        Volver
      </button>
      <Breadcrumbs>
        <Link className="text-breadcrumbs" href="/buscar">
          <span className="text-breadcrumbs cursor-pointer">Todos</span>
        </Link>
        <Link className="text-breadcrumbs" href={`/buscar?brands=${vehicle.brand}`}>
          <span className="text-breadcrumbs cursor-pointer">{vehicle.brand}</span>
        </Link>
        <Link className="text-breadcrumbs" href={`/buscar?models=${vehicle.model}`}>
          <span className="text-breadcrumbs cursor-pointer">{vehicle.model}</span>
        </Link>
      </Breadcrumbs>
    </Breadcrumbs>
  );
};

export default VehicleBreadcrumbs;
